import type { RegistryEntry, UiOptionSelect } from '../types';
import { clampTo } from '../../tools';

const LUMA_OUTPUT_FORMAT_OPTION = {
  key: 'output_format',
  label: 'Output Format',
  type: 'select',
  options: [
    { label: 'JPEG', value: 'jpeg' },
    { label: 'PNG', value: 'png' },
    { label: 'WebP', value: 'webp' },
  ],
  default: 'jpeg',
  group: 'basic',
} as UiOptionSelect;

const toLumaProviderOptions = (ui: Record<string, any>) =>
  ({
    output_format: clampTo(
      ui.output_format || 'jpeg',
      ['jpeg', 'png', 'webp'] as const,
      'jpeg',
    ),
  }) as unknown as Record<string, Record<string, any>>;

const lumaOutputFormatEntry: RegistryEntry = {
  options: [LUMA_OUTPUT_FORMAT_OPTION],
  toProviderOptions: toLumaProviderOptions,
};

export const lumaConfigs: Record<string, RegistryEntry> = {
  'uni-v1': lumaOutputFormatEntry,
};